import { DownloadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Row } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { xuatExcelNhanSuChuyenXepLuong } from '../../../services/nhanvien';
import { hideLoadingScreen, showLoadingScreen } from '../../../store/reducers/loading';

const NhanSuChuyenXepLuongThongKe = () => {
    const dispatch = useDispatch();
    const [tuNgay, setTuNgay] = useState<Dayjs | null>(dayjs().startOf('month'));
    const [denNgay, setDenNgay] = useState<Dayjs | null>(dayjs().endOf('month'));

    const handleExport = async () => {
        if (!tuNgay || !denNgay) {
            toast.warning('Vui lòng chọn Từ ngày và Đến ngày để xuất Excel');
            return;
        }
        dispatch(showLoadingScreen());
        try {
            const tuNgayStr = tuNgay.format('YYYY-MM-DD');
            const denNgayStr = denNgay.format('YYYY-MM-DD');
            const response = await xuatExcelNhanSuChuyenXepLuong(tuNgayStr, denNgayStr);
            const link = document.createElement('a');
            link.download = `ThongKeNhanSuChuyenXepLuong.xlsx`;
            const blob = new Blob([response.data || response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (err: any) {
            toast.error('Xuất báo cáo không thành công. Vui lòng thử lại');
        } finally {
            dispatch(hideLoadingScreen());
        }
    };

    return (
        <div style={{ marginTop: '23px' }}>
            <Row gutter={10}>
                <Col span={4}>
                    <label>Nhân sự sắp chuyển xếp lương:</label>
                </Col>
                <Col span={4}>
                    <DatePicker
                        value={tuNgay}
                        style={{ width: '100%' }}
                        placeholder="Từ ngày"
                        format="DD/MM/YYYY"
                        onChange={(date: Dayjs | null) => setTuNgay(date)}
                        allowClear={false}
                    />
                </Col>
                <Col span={4}>
                    <DatePicker
                        value={denNgay}
                        style={{ width: '100%' }}
                        placeholder="Đến ngày"
                        format="DD/MM/YYYY"
                        onChange={(date: Dayjs | null) => setDenNgay(date)}
                        allowClear={false}
                    />
                </Col>
                <Col>
                    <Button
                        className="hrm-btn hrm-btn-success"
                        icon={<DownloadOutlined />}
                        onClick={handleExport}
                    >
                        Xuất excel
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default NhanSuChuyenXepLuongThongKe;
